import { parseBrazilianNumber } from "../../../utils/utilityFunctions";
import { FormValues } from "../types";
import { buildSimulationHistoryData } from "./simulationHistoryData";

// A API espera strings numéricas e não remove os separadores de milhar.
function serializeNumber(value: string | number): string {
  if (String(value).trim() === "") return "";
  const parsed =
    typeof value === "number" ? value : parseBrazilianNumber(value);
  if (!Number.isFinite(parsed))
    throw new Error("Valor numérico inválido na simulação");
  return String(parsed);
}

export function buildSimulatorInvoiceData(values: FormValues, userId: string) {
  return {
    distributor: values.distribuidora,
    userId,
    ths: values.ths,
    tariffGroup: values.grupoTarifario,
    discount: serializeNumber(values.desconto),
    managementCost: serializeNumber(values.custoGestao),
    clientName: values.nomeCliente,
    cnpj: values.cnpj,
    pis: serializeNumber(values.pis),
    icms: serializeNumber(values.icms),
    cofins: serializeNumber(values.cofins),
    offPeakDemand: serializeNumber(values.demandaForaPonta),
    offPeakDemandOvertaking: serializeNumber(
      values.demandaForaPontaUltrapassagem
    ),
    offPeakConsume: serializeNumber(values.consumoForaPonta),
    peakDemandOvertaking: serializeNumber(values.demandaPontaUltrapassagem),
    peakDemand: serializeNumber(values.demandaPonta),
    peakConsume: serializeNumber(values.consumoPonta),
    projectCost: serializeNumber(values.custoProjeto),
    generation: serializeNumber(values.geracao),
    localPowerPlant: String(values.local),
    simultaneidade: serializeNumber(values.simultaneidade),
    potencyPowerPlant: serializeNumber(values.demandaUsina),
    simulationData: buildSimulationHistoryData(values),
  };
}
